import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    cartNum: 0,//购物车数量
    malMainPageConfig: {},//首页配置
    cacheMap: new Map()
  },
  mutations: {
    updateCartNum(state, payload) {
      state.cartNum = payload.currentNum
    },
    updateMalMainPageConfig(state, payload) {
      state.malMainPageConfig = payload.malMainPageConfig
    },
    updateCacheMap(state,payload){
      state.cacheMap.set(payload.key,payload.value)
    }
  }
})
